import React from 'react'
import '../common/common.scss'

const NoData = ({ className = '' }) => {
  return (
    <div className={`no-data-container ${className}`.trim()}>
       <img src='/no_data_recorded.png' alt="no-data-recorded" className={`no-recorded-data ${className ? 'no-recorded-data--compact' : ''}`.trim()} />
    </div>
  )
}

export default NoData